import Vue from 'vue'
import store from '@/store/store';
import EventBus from '@/event-bus/EventBus';
import EventsSDK from 'voicenter-events-sdk';
import { sdkEventTypes } from '@/enum/sdkEvents';
import { loggerConnectOptions } from '@/enum/socketConnectionConfig'
import parseCatch from '@/helpers/handleErrors';
import NotificationsPlugin from '@/components/NotificationPlugin';
import io from "socket.io-client"

Vue.use(NotificationsPlugin)
const app = new Vue({})
const $notify = app.$notify

let sdk = null

function onNewEvent(eventData) {
    switch (eventData.name) {
        case sdkEventTypes.CONNECT_ERROR:
            EventBus.$emit(sdkEventTypes.CONNECT_ERROR)
            break;
        case sdkEventTypes.CONNECT_TIMEOUT:
            EventBus.$emit(sdkEventTypes.CONNECT_TIMEOUT)
            break;
        default:
            break;
    }
}

export default async function initRealTimeSdk() {
    try {
        if (sdk) {
            sdk.emit(sdkEventTypes.CLOSE)
            sdk = null
        }
        let config = {
            token: store.state.users.tokenString,
            store: store,
            extensionsModuleName: 'extensions',
            queuesModuleName: 'queues',
            dialersModuleName: 'dialers',
            serverFetchStrategy: process.env.VUE_APP_EVENTS_SERVER_FETCH_STRATEGY,
            useLoginApi: true
        }
        if (process.env.VUE_APP_EVENTS_SDK_URL) {
            config.url = process.env.VUE_APP_EVENTS_SDK_URL
        }
        if (process.env.VUE_APP_EVENTS_SDK_LOGIN_URL) {
            config.loginUrl = process.env.VUE_APP_EVENTS_SDK_LOGIN_URL
        }
        if (process.env.VUE_APP_EVENTS_SDK_REFRESH_TOKEN_URL) {
            config.refreshTokenUrl = process.env.VUE_APP_EVENTS_REFRESH_TOKEN_URL
        }
        if (process.env.VUE_APP_EVENTS_SDK_SERVERS) {
            config.servers = process.env.VUE_APP_EVENTS_SDK_SERVERS
        }
        if (process.env.VUE_APP_EVENTS_SDK_OPTIONS) {
            let newOptions = {}
            try {
                newOptions = JSON.parse(process.env.VUE_APP_EVENTS_SDK_OPTIONS)
            } catch (e) {
                console.warn('Invalid sdk options format provided via env config')
            }

            const loggerUrl = process.env.VUE_APP_LOGGER_API_URL || ''

            const loggerSocket = loggerUrl ? io(loggerUrl, loggerConnectOptions) : undefined

            config = {
                ...config,
                ...newOptions,
                loggerSocketConnection: loggerSocket,
                useLogger: false // !!loggerUrl
            }
        }
        if (typeof config.servers === 'string') {
            config.servers = JSON.parse(config.servers)
        }
        sdk = new EventsSDK(config)
        await sdk.init()
        sdk.on('*', onNewEvent)
    } catch (e) {
        parseCatch(e, true)
    }
}

export async function reSyncSdk() {
    if (!sdk) {
        return
    }
    await initRealTimeSdk()
}

export async function setToken(token) {
    if (!sdk) {
        return
    }
    await sdk.setToken(token)
}

export async function retrySocketConnection() {
    $notify({
        type: 'info',
        icon: true,
        title: 'errors.realtime.connection.title',
        message: 'common.socketAttemptSync',
    })
    
    await reSyncSdk()
    
    $notify({
        type: 'success',
        icon: true,
        title: 'RealTime SDK',
        message: 'common.socketSynced',
    })
}
